import { render, staticRenderFns } from "./AssignorEdit.vue?vue&type=template&id=4bc32a31&"
import script from "./AssignorEdit.vue?vue&type=script&lang=js&"
export * from "./AssignorEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports